import axios from "axios";

/**
 * Login to frontend using admin token from admin panel
 * Call this function from admin panel to login directly to frontend
 *
 * @param {string} adminToken - The token obtained from /admin/generate-frontend-token
 * @returns {Promise<boolean>} - Success status
 */
export const loginWithAdminToken = async (adminToken) => {
  try {
    // Set the admin token in localStorage
    localStorage.setItem("admin_token", adminToken);
    localStorage.setItem("token", adminToken);
    localStorage.setItem("usertype", "admin");
    localStorage.setItem("loggedin_by", "admin");
    localStorage.setItem("is_verified", "true");
    localStorage.setItem("isAdminUser", "true");

    // Decode token to get user info
    const tokenData = parseJwt(adminToken);
    if (tokenData) {
      localStorage.setItem("saveduserid", tokenData.userId);
    }

    // Optionally redirect to a specific page
    // window.location.href = "/admin/tenant/dashboard"; // or whatever admin page

    return true;
  } catch (error) {
    console.error("Admin login failed:", error);
    return false;
  }
};

/**
 * Parse JWT token to get payload
 * @param {string} token - JWT token
 * @returns {object|null} - Token payload
 */
const parseJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Failed to parse JWT:", e);
    return null;
  }
};

/**
 * Check if user is logged in as admin
 * @returns {boolean}
 */
export const isAdminLoggedIn = () => {
  const adminToken = localStorage.getItem("admin_token");
  const userType = localStorage.getItem("usertype");
  const loggedInBy = localStorage.getItem("loggedin_by");

  return !!(adminToken && userType === "admin" && loggedInBy === "admin");
};

/**
 * Logout from admin session
 */
export const adminLogout = () => {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("token");
  localStorage.removeItem("usertype");
  localStorage.removeItem("loggedin_by");
  localStorage.removeItem("is_verified");
  localStorage.removeItem("isAdminUser");
  localStorage.removeItem("saveduserid");

  // Redirect to home or login
  window.location.href = "/home";
};
